export const variableSelector = (state) => state.variable;